module.exports = __webpack_public_path__ + "media/images/app/testimonials/carousel-third-bf768b54a8022b4e0547a01ee08887b5.webp";